import { useEffect, useMemo, useState } from 'react';
import { getJanelaDescargaDestino } from '@spark/services/descarga';
import { useLatestAsyncRequest } from '@spark/ui-components/hooks/useLatestAsyncRequest';
import { apenasDigitos } from '../utils/janelaDescarga';

export const DEBOUNCE_DESTINO_MS = 400;

// Consulta /destino só com raiz de 8 dígitos (RAIZ) ou CNPJ de 14 dígitos (CNPJ)
export const useJanelaDestino = ({ tipo, cnpjRaiz, cnpj, ignorarId }) => {
  const [destino, setDestino] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(false);
  const { beginRequest, isCurrentRequest } = useLatestAsyncRequest();

  const porCnpj = tipo === 'CNPJ';
  const digitos = porCnpj ? apenasDigitos(cnpj, 14) : apenasDigitos(cnpjRaiz, 8);

  const consulta = useMemo(() => {
    if (digitos.length !== (porCnpj ? 14 : 8)) return null;

    const params = porCnpj ? { cnpj: digitos } : { raiz: digitos };
    return ignorarId ? { ...params, ignorarId } : params;
  }, [digitos, porCnpj, ignorarId]);

  useEffect(() => {
    // Nova consulta invalida qualquer resposta ainda em andamento
    const requestId = beginRequest();
    setDestino(null);
    setErro(false);

    if (!consulta) {
      setCarregando(false);
      return undefined;
    }

    setCarregando(true);
    const timer = setTimeout(async () => {
      try {
        const resposta = await getJanelaDescargaDestino(consulta);
        if (isCurrentRequest(requestId)) setDestino(resposta ?? null);
      } catch (error) {
        if (isCurrentRequest(requestId)) {
          console.error('Erro ao consultar destino da janela de descarga:', error);
          setErro(true);
        }
      } finally {
        if (isCurrentRequest(requestId)) setCarregando(false);
      }
    }, DEBOUNCE_DESTINO_MS);

    return () => clearTimeout(timer);
  }, [beginRequest, consulta, isCurrentRequest]);

  return { destino, carregando, erro };
};

export default useJanelaDestino;
